import * as tslib_1 from "tslib";
import * as React from 'react';
import strings from 'owa-strings/owa-common-strings';
import { AriaRoles } from 'owa-accessibility';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
import { getHeaderImageData } from 'owa-theme';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { observer } from 'mobx-react';
var styles = require('./Header.scss');
var classNames = require('classnames/bind');
var HeaderLogo = observer(function (props) {
    return (React.createElement("a", { href: "", className: styles.logo, "data-is-focusable": "true" },
        React.createElement("span", { className: styles.logoText }, strings.brandName)));
});
var HeaderBase = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderBase, _super);
    function HeaderBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderBase.prototype.render = function () {
        var backgroundStyle;
        var _a = this.props, searchMode = _a.searchMode, leftCharms = _a.leftCharms, rightCharms = _a.rightCharms, headerLeftSectionStyle = _a.headerLeftSectionStyle, children = _a.children;
        var headerImageData = getHeaderImageData();
        // do not display theme image when search is active
        if (!searchMode && headerImageData.primary) {
            // Create the CSS value.
            var backgroundImageCss = "url(" + headerImageData.primary + ")";
            if (headerImageData.static) {
                // GIF may have a static image to help preloading it quickly.
                backgroundImageCss += ",url(" + headerImageData.static + ")";
            }
            backgroundStyle = { backgroundImage: backgroundImageCss };
        }
        // We place the background in its own div in the center so we can easily
        // flip it in RTL languages and we can make sure the Waffle on the left
        // stays on the left and the elements on the right stay on the right of the screen
        // when using the "space-between" css rule.
        return (React.createElement("div", { className: classNames(styles.main, searchMode && styles.inSearch) },
            React.createElement(FocusZone, { style: headerLeftSectionStyle, className: styles.headerLeftSection, direction: FocusZoneDirection.horizontal, rootProps: { role: AriaRoles.menubar } },
                leftCharms,
                React.createElement(HeaderLogo, null)),
            React.createElement("div", { className: classNames(styles.headerMiddleSection, isMailFeatureEnabled('sea-centered') && styles.headerMiddleSectionCentered) }, children),
            React.createElement("div", { style: backgroundStyle, className: classNames(styles.background, 'flipForRtl') }),
            React.createElement(FocusZone, { direction: FocusZoneDirection.horizontal, className: styles.headerRightSection, rootProps: { role: AriaRoles.menubar } }, rightCharms)));
    };
    HeaderBase = tslib_1.__decorate([
        observer
    ], HeaderBase);
    return HeaderBase;
}(React.Component));
export default HeaderBase;
//# sourceMappingURL=HeaderBase.js.map